import { createContext, useContext } from "react";
import type { PromotionManyWidgetQuery } from "gql/generated";

export type WidgetPromotion = PromotionManyWidgetQuery["promotionMany"][number];

export type WidgetPromotionsValue = {
  /** Approved, active promotions keyed by listing entity id (sorted by first date). */
  byOperator: Map<string, WidgetPromotion[]>;
  loading: boolean;
};

export const EMPTY_WIDGET_PROMOTIONS: WidgetPromotionsValue = {
  byOperator: new Map(),
  loading: false,
};

export const WidgetPromotionsContext = createContext<WidgetPromotionsValue>(
  EMPTY_WIDGET_PROMOTIONS,
);

const NO_PROMOTIONS: WidgetPromotion[] = [];

/** The listing's approved, active promotions (empty outside a provider). */
export const useOperatorPromotions = (
  operatorEntityId: string | undefined,
): WidgetPromotion[] => {
  const { byOperator } = useContext(WidgetPromotionsContext);
  return (
    (operatorEntityId && byOperator.get(operatorEntityId)) || NO_PROMOTIONS
  );
};
